module.exports = __webpack_public_path__ + "img/8.38ca1f28.jpg";